module.exports = __webpack_public_path__ + "static/media/team-leaderboard-icon.211f70cb.svg";